import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";
import styled from "styled-components";
import { Filters } from "App/shared/filterOrSearch";

import ReferenceArrayField from "components/ReferenceArrayField";

// w-full is load-bearing: in the Dashboard, this nav is a flex item
// inside EqualHeightPaddedRow (flex flex-wrap), so without an explicit
// width it shrinks to content width and the sibling <Events> section
// fits beside it on the same row.
const FiltersBar = styled.nav`
  ${tw`w-full flex flex-row mt-6 mb-3`}
`;

const Filter = ({ records, selected, label, field, ...props }) =>
  records && records.length ? (
    <Filters
      label={label}
      field={field}
      tags={records}
      tag={selected}
      allowBlank={true}
      {...props}
    />
  ) : null;

Filter.propTypes = {
  label: PropTypes.string,
  field: PropTypes.string,
  records: PropTypes.array,
  selected: PropTypes.any
};

export const ProjectsFilters = (props) => {
  const {
    onSelectRestaurant,
    onSelectEventLocation,
    restaurant,
    eventLocation
  } = props;

  return (
    <FiltersBar>
      <ReferenceArrayField
        reference="professional"
        sortBy="business_name"
        filters={{ active: true, scheduled: true }}
      >
        <Filter
          label="Restaurant"
          field="business_name"
          selected={{ slug: restaurant }}
          keyField="slug"
          onSelect={onSelectRestaurant}
        />
      </ReferenceArrayField>

      <ReferenceArrayField reference="event_locations" sortBy="name">
        <Filter
          label="Event Location"
          field="name"
          keyField="slug"
          selected={{ slug: eventLocation }}
          onSelect={onSelectEventLocation}
        />
      </ReferenceArrayField>
    </FiltersBar>
  );
};

ProjectsFilters.propTypes = {
  restaurant: PropTypes.string,
  eventLocation: PropTypes.string,
  onSelectEventLocation: PropTypes.func,
  onSelectRestaurant: PropTypes.func
};

export default ProjectsFilters;
